<template>
    <div>
      <Navbar />
      <div class="container">
        <router-view></router-view>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from './Tools/navbar.vue';
  
  export default {
    name: 'App',
    components: {
        Navbar,
    },
  };
  </script>
